import React, { useEffect } from 'react';
import {
 batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';

import Text from '../../Text/Text';
import StepperNavigationBtn from './StepperNavigationBtn';
import { setCreateNewOrderData } from '../../../thunks/coilovers/orders/createNewOrder';
import Input from '../../Input/Input';
import CustomSelect from '../../Select/CustomSelect';
import getCountriesList from '../../../thunks/general/getCountriesList';
import getCountriesStateList from '../../../thunks/general/getCountriesStateList';

const OrderClientForm = () => {
  const dispatch = useDispatch();
  const {
    createNewOrderData: {
      firstName,
      lastName,
      address,
      address2,
      country,
      state: countryState,
      zip,
      city,
      phone,
      email
    },
    getCountriesList: {
      list: countryList,
      loading: countryListLoading
    },
    getCountriesStateList: {
      list: countryStateList,
      loading: countryStateListLoading
    },
  } = useSelector((state) => ({
    createNewOrderData: state.createNewOrder?.data,
    getCountriesList: state.getCountriesList,
    getCountriesStateList: state.getCountriesStateList
  }), shallowEqual);

  useEffect(() => {
    if (!countryList?.length) {
      dispatch(getCountriesList());
      dispatch(getCountriesStateList(countryState || 'US'));
    }
  }, []);

  useEffect(() => {
    batch(() => {
      dispatch(getCountriesStateList(country));
    });
  }, [country]);

  const inputData = [
    [
      {
        id: 'firstName',
        value: firstName,
        placeholder: 'First name',
        multiline: false,
        required: true
      },
      {
        id: 'lastName',
        value: lastName,
        placeholder: 'Last name',
        multiline: false,
        required: true
      }
    ],
    [
      {
        id: 'address',
        value: address,
        placeholder: 'Address',
        multiline: false,
        required: true
      },
      {
        id: 'address2',
        value: address2,
        placeholder: 'Address2',
        multiline: false
      },
    ],
    [
      {
        id: 'country',
        value: countryList?.filter(({ value: val }) => val === country),
        placeholder: 'Country',
        multiline: false,
        list: countryList,
        type: 'select',
        loading: countryListLoading,
        required: true
      },
      {
        id: 'state',
        value: !countryStateList?.length
          ? countryState
          : countryStateList?.filter(({ value: val }) => val === countryState),
        placeholder: 'State',
        multiline: false,
        list: countryStateList,
        type: !!countryStateList?.length && 'select',
        loading: countryStateListLoading,
        required: true
      },
      {
        id: 'city',
        value: city,
        placeholder: 'City',
        multiline: false,
        required: true
      },
      {
        id: 'zip',
        value: zip,
        placeholder: 'ZIP',
        multiline: false,
        required: true
      },
    ],
    [
      {
        id: 'phone',
        value: phone,
        placeholder: 'Phone number',
        multiline: false,
        required: true
      },
      {
        id: 'email',
        value: email,
        placeholder: 'Email',
        multiline: false
      },
    ]
  ];

  return (
    <div className="flex flex-col flex-1">
      <div className="pb-[50px]">
        <Text text="Client Details" textStyle="text-[20px] text-[#252F4A] mb-[6px]" />
      </div>
      <div>
        {inputData?.map((items, index) => (
          <div className="mb-[30px]" key={['section', index].join('_')}>
            <div className="flex flex-row gap-[20px]">
              {items?.map(({
                id, value, placeholder, multiline, type, list, loading, required
              }) => (
                <div className="flex1" key={id}>
                  <Text
                    text={placeholder}
                    textStyle="text-[#252F4A] text-[14px]"
                    styleContainer="mb-[10px]"
                    required={required}
                  />
                  {type === 'select' ? (
                    <CustomSelect
                      options={list}
                      value={value}
                      isMulti={false}
                      isLoading={loading}
                      isSearchable
                      onChange={(data) => dispatch(setCreateNewOrderData({ [id]: data?.value }))}
                      containerStyle={{
                        paddingTop: 10,
                        paddingBottom: 10,
                        paddingLeft: 26,
                        paddingRight: 26,
                        fontSize: 16
                      }}
                      placeholder={placeholder}
                    />
                  ) : (
                    <Input
                      type="text"
                      name={id}
                      value={value}
                      placeholder={placeholder}
                      multiline={multiline}
                      rows={3}
                      onChange={({ target: { value: val } }) => dispatch(setCreateNewOrderData({ [id]: val }))}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <StepperNavigationBtn next="shipping" prev="product" />
    </div>
  );
};

export default OrderClientForm;
